import React, { Fragment, Component } from 'react';
import cn from 'classnames';
import moment from 'moment';
import { Card } from 'reactstrap';

export default class CustomerSummaryCard extends Component {
  renderAddress = () => {
    const properties = ['streetAddress', 'streetAddress2', 'suburb', 'postcode', 'country'];
    const hasAtLeastOneProperty = properties.some(p => !!this.props[p]);
    if (!hasAtLeastOneProperty) {
      return null;
    }

    return (
      <Fragment>
        <h4 className="table-header mv0">Address</h4>
        {properties.map(p => (!!this.props[p] ? <p key={p}>{this.props[p]}</p> : null))}
      </Fragment>
    );
  };

  renderXero = () => {
    const { xero } = this.props;
    const inner = xero ? xero.status : 'Not synced';

    return (
      <Fragment>
        <h4 className="table-header mv0">Xero</h4>
        <p>{inner}</p>
      </Fragment>
    );
  };

  render() {
    const { className, birthDate, fin } = this.props;

    return (
      <Card className={cn(className, 'pa3')}>
        <h3 className="f4 mt0">Summary</h3>
        {this.renderAddress()}
        {birthDate && (
          <Fragment>
            <h4 className="table-header mv0">Contact's birth date</h4>
            <p>{moment(birthDate).format('Do MMMM, YYYY')}</p>
          </Fragment>
        )}
        {fin && (
          <Fragment>
            <h4 className="table-header mv0">FIN number</h4>
            <p>{fin}</p>
          </Fragment>
        )}
        {this.renderXero()}
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/customerSummaryCard/customerSummaryCard.jsx